import React, { useState, useEffect, useRef } from "react";
import "./index.scss";
import { NavLink } from "react-router-dom";
import ayesalonLogo from "../../cdn/ayesalon_logo_smart_salon_management.svg";
import CalendarToday from "@mui/icons-material/CalendarToday";
import PersonAdd from "@mui/icons-material/PersonAdd";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AccountTree from "@mui/icons-material/AccountTree";
import Percent from "@mui/icons-material/Percent";
import BarChart from "@mui/icons-material/BarChart";
import CurrencyRupee from "@mui/icons-material/CurrencyRupee";
import School from "@mui/icons-material/School";
import Tune from "@mui/icons-material/Tune";
import ShoppingBag from "@mui/icons-material/ShoppingBag";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CreditCard from "@mui/icons-material/CreditCard";
import QuestionAnswer from "@mui/icons-material/QuestionAnswer";
import Campaign from "@mui/icons-material/Campaign";
import HeadphonesIcon from "@mui/icons-material/Headset";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CardGiftcard from "@mui/icons-material/CardGiftcard";
import Storefront from "@mui/icons-material/Storefront";
import { Translate } from "react-auto-translate";
import ui from "../../mockData";

const SIDEBAR_ICON_MAP = {
  "calendar outline": CalendarToday,
  "user plus": PersonAdd,
  "user circle": AccountCircle,
  sitemap: AccountTree,
  payment: CreditCard,
  percent: Percent,
  "chart bar outline": BarChart,
  ils: CurrencyRupee,
  university: School,
  sliders: Tune,
  "shopping bag": ShoppingBag,
  "address book": MenuBookIcon,
  "question circle": QuestionAnswer,
  campaign: Campaign,
  gift: CardGiftcard,
  storefront: Storefront,
};

function SidebarIcon({ name, ...props }) {
  const IconComponent = SIDEBAR_ICON_MAP[name];
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
}

function Sidebar({ pathMap }) {
  const [isMobile, setIsMobile] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    function updateDimensions() {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setIsMobile(window.innerWidth <= 420);
      }, 100);
    }
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
      clearTimeout(timerRef.current);
    };
  }, []);

  function handleMobileQuitClick() {
    document.getElementById("side-bar").style.width = "0px";
    document.getElementById("mobile_quit").style.display = "none";
  }

  if (!pathMap) return null;

  const { sidebarLinksMap } = ui;
  const routes = [];

  sidebarLinksMap.forEach((linkMap, index) => {
    const { link, name, icon } = linkMap;
    if (link in pathMap && pathMap[link]) {
      routes.push(
        <li key={index} data-testid={`sidebar-${name.toLowerCase()}`}>
          <NavLink exact to={link} className="nav-item" activeClassName="nav-item--active" data-testid={`sidebar-link-${name.toLowerCase()}`}>
            <span className="nav-icon">
              <SidebarIcon name={icon} />
            </span>
            <span className="nav-label">
              <Translate>{name}</Translate>
            </span>
          </NavLink>
        </li>
      );
    }
  });

  return [
    <div key={1} id="mobile_quit" className="mobile_quit" onClick={handleMobileQuitClick} />,
    <div key={2} id="side-bar" className={`side-bar${isMobile ? " side-bar--mobile" : ""}`}>
      {/* <div className="sidebar-brand">
        <img src={ayesalonLogo} alt="Ayesalon" className="sidebar-logo" />
      </div> */}
      <ul>
        {routes}
        <li data-testid="sidebar-help">
          <NavLink exact to="/help" className="nav-item" activeClassName="nav-item--active" data-testid="sidebar-link-help">
            <span className="nav-icon"><HelpOutlineIcon /></span>
            <span className="nav-label"><Translate>Help</Translate></span>
          </NavLink>
        </li>
      </ul>
      <div className="sidebar-support">
        <HeadphonesIcon className="support-icon" />
        <div className="support-details">
          <a href="tel:+918796243405" className="support-phone">+91-8796243405</a>
          <a href="mailto:Support@ayesalon.com" className="support-email">Support@ayesalon.com</a>
        </div>
      </div>
    </div>,
  ];
}

export default Sidebar;
